/**
 * A new item ID chosen in the browser: a UUID version 7 in canonical form, as the server
 * writes them (`server/src/dmw/kernel/ids.py`). A form chooses the ID of an item it creates
 * when a later edit of the same change set must name it, such as a step that pins a new
 * prompt (reviews.md R-8, `CreateItemBody.item_id`).
 */
export function newItemId(now: number = Date.now(), random: Uint8Array = crypto.getRandomValues(new Uint8Array(10))): string {
  const bytes = new Uint8Array(16);
  // 48 bits of Unix milliseconds, then version 7, 12 random bits, variant 10, 62 random bits.
  let milliseconds = now;
  for (let index = 5; index >= 0; index -= 1) {
    bytes[index] = milliseconds % 256;
    milliseconds = Math.floor(milliseconds / 256);
  }
  bytes.set(random, 6);
  bytes[6] = 0x70 | ((bytes[6] ?? 0) & 0x0f);
  bytes[8] = 0x80 | ((bytes[8] ?? 0) & 0x3f);
  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
